<template>
  <router-view />
</template>
<script>
export default {
  name: 'AppPage',
  created() {
  },
}
</script>